import { colors, fontSize, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    padding: spacing.medium,
  }),

  checkbox: css({
    width: '100%',
    marginBottom: spacing.medium,
    label: {
      fontSize: fontSize.default,
    },
    '& input': {
      borderColor: colors.grayChateau,
    },
  }),

  cityCheckbox: css({
    width: '100%',
    marginBottom: spacing.medium,
    paddingLeft: spacing.medium,
    label: {
      fontSize: fontSize.default,
    },
    '& input': {
      borderColor: colors.grayChateau,
    },
  }),

  buttonWrapper: css({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'white',
    bottom: 0,
    left: 0,
    height: '60px',
    borderTop: `1px solid ${colors.mystic}`,
    display: 'block',
  }),

  action: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
    marginTop: '10px',
  }),
}

export default styles
